import React from 'react'
import SearchInput from '@beatgig/components/search-input'
import { useRouting } from 'expo-next-react-navigation'
import { Platform } from 'react-native'
import useGlobalArtistSearchQueryState from '../hooks/use-global-search-state'

type Props = {
  shouldNavigateOnFocus?: boolean
}

export default React.memo(function SmartArtistSearchInput({
  shouldNavigateOnFocus = true,
}: Props) {
  const { pathname, canGoBack, navigate, goBack } = useRouting()
  const [query, setQuery] = useGlobalArtistSearchQueryState()
  const isOnSearchScreen = pathname?.includes('search')

  const willNavigateOnFocus =
    shouldNavigateOnFocus && !isOnSearchScreen && Platform.OS === 'web'

  return (
    <SearchInput
      onFocus={() => {
        if (willNavigateOnFocus) {
          navigate({
            routeName: 'search',
          })
        }
      }}
      value={query}
      onChangeText={setQuery}
      showBack={canGoBack() && isOnSearchScreen}
      onClear={() => {
        setQuery('')
        if (canGoBack && Platform.OS === 'web' && isOnSearchScreen) {
          // goBack()
        }
      }}
      onGoBack={() => {
        canGoBack() && goBack()
      }}
    />
  )
})
